exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.layoutTraficVisiteurs.smallChat .traficInfosVisiteur {\n    -ms-flex-preferred-size: 75% !important;\n    flex-basis: 75% !important;\n    max-width: 75% !important;\n}\n.layoutTraficVisiteurs.smallChat .traficChatVisiteur {\n    position: absolute;\n    top: calc(100% - 58px);\n    right: 4px;\n    width: 25%;\n    -ms-flex-preferred-size: 25% !important;\n    flex-basis: 25% !important;\n    max-width: 25% !important;\n}\n.layoutTraficVisiteurs {\n  height: calc(100vh - 104px) !important;\n}\n.cardTraficVisiteurs {\n  height:100% !important;\n}\n.wz_contentListesVisiteurs {\n  height: calc(100vh - 176px);\n  overflow: auto;\n  position: relative;\n}\n.wz_loadingChat {\n  top: calc(50% - 35px);\n  position: relative;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/trafic/Visitors.vue
// module id = +s/v
// module chunks = 1